import { type SetAllLayouts, type SetCurrentLayouts } from "../types";

const setAllLayouts: SetAllLayouts = (state, action) => {
  state.layouts = action.payload;
};

const setCurrentLayouts: SetCurrentLayouts = (state, action) => {
  state.currentLayouts = action.payload;
};

export const layoutReducers = {
  setAllLayouts,
  setCurrentLayouts,
};
